module.exports = __webpack_public_path__ + "img/content-img1_4.1c2f24f8.png";